import mixpanel from 'mixpanel-browser';
import moment from 'moment';

//  FOR RESERVATION FAILED --->>
const reservationSuccess = (reservationRespData, totalCost) => {
  const { roomTypeName, reservationData } = reservationRespData?.data;
  const { reservations } = reservationData;
  const { reservationId, arrivalDate, departureDate } = reservations[0];
  const dateIn = moment(arrivalDate).format('ddd, MMM D, YYYY');
  const dateOut = moment(departureDate).format('ddd, MMM D, YYYY');
  const pushtell = localStorage.getItem('PUSHTELL-bookingEngine');
  if (pushtell) {
    const obj = {
      dateIn,
      dateOut,
      totalCost,
      roomTypeName,
      reservationId,
      reservation: 'success',
    };
    if (process.env.REACT_APP_SERVER == 'production') {
      mixpanel.track(`${pushtell} - User Reservation Production`, obj);
    } else {
      mixpanel.track(`${pushtell} - User Reservation Staging`, obj);
    }
  }
};

// FOR RESERVATION FAILED -->>
const reservationFailed = () => {
  const pushtell = localStorage.getItem('PUSHTELL-bookingEngine');
  const obj = { reservation: 'failed' };
  if (pushtell) {
    if (process.env.REACT_APP_SERVER == 'production') {
      mixpanel.track(`${pushtell} - User Reservation Production`, obj);
    } else {
      mixpanel.track(`${pushtell} - User Reservation Staging`, obj);
    }
  }
};

// FOR PAGE  INITIAL VISIT -->>
const initialVisitor = (isInitial) => {
  const pushtell = localStorage.getItem('PUSHTELL-bookingEngine');
  if (pushtell && isInitial) {
    if (process.env.REACT_APP_SERVER == 'production') {
      mixpanel.track(`${pushtell} - User Visits Production`);
    } else {
      mixpanel.track(`${pushtell} - User Visits Staging`);
    }
  }
};

export const mixPanelEvents = {
  reservationSuccess,
  reservationFailed,
  initialVisitor,
};
